var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgReferCandidateIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 14,
    viewBox: "0 0 16 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.81991 4.86004C7.01285 4.86004 7.97991 3.89297 7.97991 2.70004C7.97991 1.5071 7.01285 0.540039 5.81991 0.540039C4.62698 0.540039 3.65991 1.5071 3.65991 2.70004C3.65991 3.89297 4.62698 4.86004 5.81991 4.86004Z",
    stroke: "currentColor",
    strokeWidth: 1.08
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.44 7.02002H4.2C2.70883 7.02002 1.5 8.22886 1.5 9.72002V9.99002V12.96H10.14V9.72002C10.14 8.22886 8.93116 7.02002 7.44 7.02002Z",
    stroke: "currentColor",
    strokeWidth: 1.08,
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3799 4.32008L14.9999 2.70008M14.9999 2.70008L13.3799 1.08008M14.9999 2.70008H10.6799",
    stroke: "currentColor",
    strokeWidth: 1.08
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgReferCandidateIcon);
export default __webpack_public_path__ + "static/media/refer-candidate-icon.5a854b2f.svg";
export { ForwardRef as ReactComponent };